import { Link } from "react-router-dom";
import Header from "@/components/Header";
import SeoHead from "@/components/SeoHead";
import { Button } from "@/components/ui/button";
import { House, ShieldCheck, Phone } from "@phosphor-icons/react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-slate-50">
      <SeoHead
        title="Seite nicht gefunden | Servus Autoglas"
        description="Diese Seite existiert nicht mehr. Hier geht es zu unseren Autoglas-Leistungen, Scheibentönung und Sattlerei."
        noindex
      />
      <Header />
      <main className="max-w-xl mx-auto px-4 py-20 text-center" data-testid="not-found-page">
        <p className="text-7xl font-extrabold text-slate-200">404</p>
        <h1 className="mt-4 text-2xl font-bold text-slate-900">Diese Seite gibt es nicht (mehr)</h1>
        <p className="mt-3 text-slate-600">Kein Problem — hier finden Sie direkt zum Ziel:</p>
        <div className="mt-8 grid gap-3">
          <Button asChild className="h-12 bg-blue-600 hover:bg-blue-700">
            <Link to="/" data-testid="nf-home"><House size={18} className="mr-2" /> Zur Startseite</Link>
          </Button>
          <Button asChild variant="outline" className="h-12">
            <Link to="/schaden-melden" data-testid="nf-claim"><ShieldCheck size={18} className="mr-2" /> Glasschaden melden</Link>
          </Button>
          <Button asChild variant="outline" className="h-12">
            <Link to="/leistungen" data-testid="nf-services">Alle Leistungen ansehen</Link>
          </Button>
          <a
            href="tel:+49621527429"
            className="inline-flex items-center justify-center gap-2 h-12 rounded-md border border-slate-200 bg-white text-sm font-medium hover:bg-slate-50"
            data-testid="nf-call"
          >
            <Phone size={18} /> 0621 527429 anrufen
          </a>
        </div>
      </main>
    </div>
  );
}
